<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :scrollable="true"
  >
    <div class="row mx-0">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="col-md-12 table-responsive" id="div-tabla-anular">
              <table id="tb-anular" class="table table-bordered">
                  <caption class="mx-0 px-0"></caption>
                  <thead class="bg-main" style="font-size: 12px">
                      <tr class="text-white text-center align-middle">
                        <th scope="col">PACIENTE</th>
                        <th scope="col">ACTO MED.</th>
                        <th scope="col">HORA</th>
                        <th scope="col">SERVICIO</th>
                        <th scope="col">COMENTARIO</th>
                      </tr>
                  </thead>
                  <tbody class="border-main" style="font-size: 10.5">
                    <tr v-for="(det, index) in cpData" :key="index" class="text-center align-middle">
                      <template>
                        <td>{{ det.patient ? det.patient.name : '-' }}</td>
                        <td>
                            <template v-if="det.medicalact">
                                {{ det.medicalact.id }} - {{ det.medicalact.date | formatDate }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>{{ det.start_time }} - {{ det.end_time  }}</td>
                        <td>{{ det.services ? det.services.name : '-' }}</td>
                        <td>{{ det.comment ? det.comment : '-' }}</td>
                      </template>
                    </tr>
                  </tbody>
              </table>
          </div>
      </div>
    </div>
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  name: "c-cModalDetalleReserva",
  components: {
    CModal,
  },
  data() {
    return {
      tabla: [],
    };
  },
  created () {
  },
  computed: {
    cpData() {
      let show = [];
      this.item.forEach((element) => {
        show.push(element);
      });
      this.tabla = show;
      return show;
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    item: [],
    id: Number,
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModal");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>
<style scoped>
.align-middle{
  vertical-align: middle;
}
</style>
